import { getActiveAssets } from "../../../../common/api/decimal/methods/license";
import { LoaderFunction, useFetcher } from "react-router-dom";

export type LicenseData = Awaited<ReturnType<typeof getActiveAssets>>;

export const licenseLoader: LoaderFunction = async (): Promise<LicenseData> => {
  const licenseResponse = await getActiveAssets(1);
  return licenseResponse;
};

export function useLicenseFetcher() {
  return useFetcher<LicenseData>({ key: "search-license" });
}
